/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, Tooltip } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import IconEmpty from '../../../assets/Images/icons/empty';
import ModalConfirm from '../../../components/Shared/modal/confirm';
import RiskRegisterService from '../../../services/RiskRegister.service';
import UserService from '../../../services/UserService';
import { STATUS_ID } from '../STATUS_ID';
import ModalAddActivity from './components/ModalAddActivity';

export default function Activity({ riskInfo, getDetailInfo, mode }) {
    const { t } = useTranslation();
    const { riskId } = useParams();

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [activityId, setSelect] = useState('');

    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);

    const activityList = riskInfo?.activityList;
    const totalCount = riskInfo?.activityList?.length;

    const onSubmit = () => {
        setLoading(true);
        setTimeout(async () => {
            try {
                const { data } = await RiskRegisterService.deleteActivity(
                    riskId,
                    activityId
                );
                if (data?.resultCode === 1) {
                    setLoading(false);
                    setOpenConfirm(false);
                    getDetailInfo();
                }
            } catch (error) {
                console.log(error);
                setLoading(false);
                setOpenConfirm(false);
            }
        }, 1300);
    };

    const checkPermissions = () => {
        if (admin) return true;

        const isReviewedOrWaiting =
            riskInfo?.status === STATUS_ID.REVIEWED ||
            riskInfo?.status === STATUS_ID.WAITING_FOR_REVIEW;

        const isConnectOrCloneMode = mode === 'connect' || mode === 'clone';

        return isReviewedOrWaiting || isConnectOrCloneMode;
    };

    return (
        <>
            <div className="col-span-1 bg-white h-max rounded-xl p-4 py-6 my-4">
                <div
                    className="text-sm font-semibold pb-2 flex justify-between items-center"
                    style={{ borderBottom: '3px solid #F4F6FC' }}
                >
                    <span>
                        {t('RR.OtherRelatedActivities')}{' '}
                        <span class="text-error">*</span>
                    </span>
                    <Button
                        htmlType="button"
                        type="link"
                        className="text-[#1890ff]"
                        hidden={checkPermissions()}
                        onClick={() => setOpen(true)}
                    >
                        + {t('RR.AddActivity')}
                    </Button>
                </div>
                {activityList?.length > 0 ? (
                    <div className="overflow-auto max-h-[45vh]">
                        <div className="text-xs text-gray-500 font-semibold mt-6">
                            {t('TotalAcitivity', { length: totalCount })}
                        </div>
                        {activityList?.map((item, index) => (
                            <div
                                key={item.activityName}
                                style={{ background: '#F5F6FF' }}
                                className="px-4 rounded-md mt-4"
                            >
                                <div className="flex justify-between items-center">
                                    <div className="font-semibold py-3">
                                        <div className="align-middle inline-block">
                                            {item.activityName}
                                        </div>
                                    </div>
                                    <div
                                        className="font-medium py-3 cursor-pointer"
                                        style={{ color: '#1890FF' }}
                                    >
                                        <div
                                            className="hover:opacity-80 rounded-md"
                                            style={{
                                                backgroundColor: '#EEE5FF',
                                            }}
                                        >
                                            <Tooltip
                                                placement="bottom"
                                                title="Remove"
                                                className="cursor-pointer hover:opacity-80"
                                            >
                                                <button
                                                    hidden={checkPermissions()}
                                                    onClick={() => {
                                                        setSelect(
                                                            item?.activityId
                                                        );
                                                        setOpenConfirm(true);
                                                    }}
                                                    style={{
                                                        borderRadius: 6,
                                                        fontSize: '1rem',
                                                        padding: '6px 10px',
                                                        color: '#7B67FB',
                                                    }}
                                                >
                                                    {dIcon}
                                                </button>
                                            </Tooltip>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="h-[20vh] grid items-center justify-center">
                        <div className="-my-20">
                            <IconEmpty />
                        </div>
                    </div>
                )}
            </div>
            <ModalAddActivity
                open={open}
                riskInfo={riskInfo}
                handelClose={() => setOpen(false)}
                getDetailInfo={getDetailInfo}
            />
            <ModalConfirm
                loading={loading}
                text={t('Do you want to confirm')}
                open={openConfirm}
                handelOk={onSubmit}
                handelClose={() => setOpenConfirm(false)}
            />
        </>
    );
}

const dIcon = (
    <svg
        width="15"
        height="15"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.9998 2.18332e-08C7.54871 -7.72662e-05 8.07782 0.205044 8.48324 0.575088C8.88866 0.945132 9.1411 1.45337 9.191 2H12.5998C12.7518 2.00005 12.8982 2.0578 13.0092 2.16158C13.1203 2.26536 13.1879 2.40744 13.1982 2.5591C13.2086 2.71077 13.161 2.86071 13.0651 2.97864C12.9691 3.09656 12.832 3.17368 12.6814 3.1944L12.5998 3.2H12.1334L11.1198 11.984C11.0747 12.3739 10.8878 12.7336 10.5947 12.9947C10.3016 13.2558 9.92273 13.4001 9.5302 13.4H4.4694C4.07688 13.4001 3.69804 13.2558 3.40494 12.9947C3.11184 12.7336 2.92494 12.3739 2.8798 11.984L1.8654 3.2H1.3998C1.25481 3.19999 1.11473 3.14749 1.00546 3.05219C0.896189 2.95689 0.825123 2.82524 0.805405 2.6816L0.799805 2.6C0.799811 2.45501 0.852319 2.31493 0.947618 2.20566C1.04292 2.09638 1.17456 2.02532 1.3182 2.0056L1.3998 2H4.8086C4.85851 1.45337 5.11095 0.945132 5.51637 0.575088C5.92179 0.205044 6.4509 -7.72662e-05 6.9998 2.18332e-08ZM5.7998 5C5.6038 5 5.4398 5.124 5.4062 5.2872L5.3998 5.3504V10.2504L5.4062 10.3128C5.4398 10.476 5.6038 10.6 5.7998 10.6C5.9958 10.6 6.1598 10.476 6.1934 10.3128L6.1998 10.2496V5.3512L6.1934 5.2872C6.1598 5.1248 5.9958 5 5.7998 5ZM8.1998 5C8.0038 5 7.8398 5.124 7.8062 5.2872L7.7998 5.3504V10.2504L7.8062 10.3128C7.8398 10.476 8.0038 10.6 8.1998 10.6C8.3958 10.6 8.5598 10.476 8.5934 10.3128L8.5998 10.2496V5.3512L8.5934 5.2872C8.5598 5.1248 8.3958 5 8.1998 5ZM6.9998 1.2C6.5158 1.2 6.1118 1.544 6.0198 2H7.9798C7.887 1.544 7.4838 1.2 6.9998 1.2Z"
            fill="#7B67FB"
        />
    </svg>
);
